(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["derspilot-mega-menu"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    const runWithTransition = (callback) => {
      if (document.startViewTransition && !desktopQuery.matches) {
        document.startViewTransition(callback);
        return;
      }

      callback();
    };

    const closeDetails = (root, except) => {
      root.querySelectorAll('[data-dp-details][open]').forEach((details) => {
        if (details !== except) {
          details.removeAttribute('open');
        }
      });
    };

    const initMenu = (root) => {
      if (root.dataset.dpReady === 'true') {
        return;
      }

      root.dataset.dpReady = 'true';

      const toggle = root.querySelector('[data-dp-mobile-toggle]');
      const label = root.querySelector('[data-dp-mobile-label]');
      const detailsItems = root.querySelectorAll('[data-dp-details]');
      const utilityDetails = root.querySelectorAll('[data-dp-utility-details]');
      const autoSubmitControls = root.querySelectorAll('[data-dp-submit-on-change]');

      const setMobileOpen = (open) => {
        runWithTransition(() => {
          root.classList.toggle('dp-mega-menu--mobile-open', open);
          if (toggle) {
            toggle.setAttribute('aria-expanded', String(open));
          }
          if (label) {
            label.textContent = open ? label.dataset.closeLabel : label.dataset.openLabel;
          }
        });
      };

      if (toggle) {
        toggle.addEventListener('click', () => {
          setMobileOpen(!root.classList.contains('dp-mega-menu--mobile-open'));
        });
      }

      detailsItems.forEach((details) => {
        let closeTimer;

        details.addEventListener('toggle', () => {
          if (details.open && desktopQuery.matches) {
            closeDetails(root, details);
          }
        });

        details.addEventListener('pointerenter', () => {
          if (root.dataset.hover !== 'true' || !desktopQuery.matches) {
            return;
          }

          window.clearTimeout(closeTimer);
          closeDetails(root, details);
          details.setAttribute('open', '');
        });

        details.addEventListener('pointerleave', () => {
          if (root.dataset.hover !== 'true' || !desktopQuery.matches) {
            return;
          }

          closeTimer = window.setTimeout(() => {
            details.removeAttribute('open');
          }, 140);
        });
      });

      utilityDetails.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) {
            utilityDetails.forEach((other) => {
              if (other !== details) {
                other.removeAttribute('open');
              }
            });
          }
        });
      });

      autoSubmitControls.forEach((control) => {
        control.addEventListener('change', () => {
          if (control.form && typeof control.form.requestSubmit === 'function') {
            control.form.requestSubmit();
            return;
          }

          if (control.form) {
            control.form.submit();
          }
        });
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target) && desktopQuery.matches) {
          closeDetails(root);
        }
        if (!root.contains(event.target)) {
          utilityDetails.forEach((details) => {
            details.removeAttribute('open');
          });
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDetails(root);
          utilityDetails.forEach((details) => {
            details.removeAttribute('open');
          });
          setMobileOpen(false);
        }
      });

      desktopQuery.addEventListener('change', () => {
        setMobileOpen(false);
        detailsItems.forEach((details) => {
          if (!desktopQuery.matches && details.dataset.mobileOpen === 'true') {
            details.setAttribute('open', '');
          }
        });
      });

      if (!desktopQuery.matches) {
        detailsItems.forEach((details) => {
          if (details.dataset.mobileOpen === 'true') {
            details.setAttribute('open', '');
          }
        });
      }
    };

    const initAll = () => {
      document.querySelectorAll('[data-dp-mega-menu]').forEach(initMenu);
    };

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galelry-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'dp-cinematic-gallery-favorites';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const readFavorites = () => {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      } catch (error) {
        return [];
      }
    };

    const writeFavorites = (favorites) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(favorites));
      } catch (error) {}
    };

    const runTransition = (callback) => {
      if (!reducedMotion && document.startViewTransition) {
        document.startViewTransition(callback);
        return;
      }
      callback();
    };

    const initializeGallery = (gallery) => {
      if (gallery.dataset.dpGalleryReady === 'true') return;
      gallery.dataset.dpGalleryReady = 'true';

      const track = gallery.querySelector('[data-gallery-track]');
      const cards = Array.from(gallery.querySelectorAll('[data-gallery-card]'));
      const dialog = gallery.querySelector('[data-gallery-dialog]');
      const dialogImage = gallery.querySelector('[data-gallery-dialog-image]');
      const dialogTitle = gallery.querySelector('[data-gallery-dialog-title]');
      const dialogText = gallery.querySelector('[data-gallery-dialog-text]');
      const dialogLink = gallery.querySelector('[data-gallery-dialog-link]');
      const dialogLinkLabel = gallery.querySelector('[data-gallery-dialog-link-label]');
      let currentIndex = 0;

      if ('IntersectionObserver' in window && !reducedMotion) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });

        cards.forEach((card) => observer.observe(card));
      } else {
        cards.forEach((card) => card.classList.add('is-visible'));
      }

      const finePointer = window.matchMedia('(pointer: fine)').matches;
      if (gallery.dataset.tilt === 'true' && finePointer && !reducedMotion) {
        gallery.querySelectorAll('[data-gallery-tilt]').forEach((card) => {
          card.addEventListener('pointermove', (event) => {
            const rect = card.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            const rotateY = (x - 50) * 0.13;
            const rotateX = (50 - y) * 0.1;
            card.style.setProperty('--mx', `${x}%`);
            card.style.setProperty('--my', `${y}%`);
            card.style.setProperty('--rx', `${rotateX}deg`);
            card.style.setProperty('--ry', `${rotateY}deg`);
          });

          card.addEventListener('pointerleave', () => {
            card.style.setProperty('--mx', '50%');
            card.style.setProperty('--my', '50%');
            card.style.setProperty('--rx', '0deg');
            card.style.setProperty('--ry', '0deg');
          });
        });
      }

      const activeCards = () => cards.filter((card) => !card.classList.contains('is-filter-hidden'));

      gallery.querySelectorAll('[data-gallery-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.galleryFilter;
          gallery.querySelectorAll('[data-gallery-filter]').forEach((filterButton) => {
            const active = filterButton === button;
            filterButton.classList.toggle('is-active', active);
            filterButton.setAttribute('aria-pressed', String(active));
          });

          runTransition(() => {
            cards.forEach((card) => {
              const matches = filter === 'all' || card.dataset.galleryCategory === filter;
              card.classList.toggle('is-filter-hidden', !matches);
            });
          });
        });
      });

      gallery.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!track) return;
          const direction = button.dataset.galleryScroll === 'next' ? 1 : -1;
          track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
        });
      });

      const updateFavoriteButton = (button) => {
        const card = button.closest('[data-gallery-card]');
        if (!card) return;
        const favorites = readFavorites();
        button.setAttribute('aria-pressed', String(favorites.includes(card.dataset.galleryFavoriteKey)));
      };

      gallery.querySelectorAll('[data-gallery-favorite]').forEach((button) => {
        updateFavoriteButton(button);
        button.addEventListener('click', () => {
          const card = button.closest('[data-gallery-card]');
          if (!card) return;
          const key = card.dataset.galleryFavoriteKey;
          const favorites = readFavorites();
          const nextFavorites = favorites.includes(key) ? favorites.filter((item) => item !== key) : [...favorites, key];
          writeFavorites(nextFavorites);
          updateFavoriteButton(button);
        });
      });

      const showSlide = (index) => {
        const slides = activeCards();
        if (!slides.length || !dialog || !dialogImage) return;
        currentIndex = (index + slides.length) % slides.length;
        const card = slides[currentIndex];
        const opener = card.querySelector('[data-gallery-open]');
        const fullImage = opener ? opener.dataset.galleryFull : '';

        if (!fullImage) return;

        dialogImage.src = fullImage;
        dialogImage.alt = opener.dataset.galleryAlt || card.dataset.galleryTitle || '';
        dialogTitle.textContent = card.dataset.galleryTitle || '';
        dialogText.textContent = card.dataset.galleryText || '';

        if (card.dataset.galleryLink) {
          dialogLink.hidden = false;
          dialogLink.href = card.dataset.galleryLink;
          dialogLinkLabel.textContent = card.dataset.galleryLinkLabel || '';
        } else {
          dialogLink.hidden = true;
          dialogLink.removeAttribute('href');
          dialogLinkLabel.textContent = '';
        }
      };

      const openDialog = (card) => {
        const opener = card.querySelector('[data-gallery-open]');
        if (!opener || !opener.dataset.galleryFull) return;
        const slides = activeCards();
        const index = slides.indexOf(card);
        showSlide(index < 0 ? 0 : index);

        if (!dialog.open) {
          if (dialog.showModal) {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        }
      };

      cards.forEach((card) => {
        const opener = card.querySelector('[data-gallery-open]');
        if (!opener) return;
        opener.addEventListener('click', () => openDialog(card));
      });

      gallery.querySelectorAll('[data-gallery-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });

      gallery.querySelector('[data-gallery-dialog-previous]')?.addEventListener('click', () => showSlide(currentIndex - 1));
      gallery.querySelector('[data-gallery-dialog-next]')?.addEventListener('click', () => showSlide(currentIndex + 1));

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') showSlide(currentIndex - 1);
        if (event.key === 'ArrowRight') showSlide(currentIndex + 1);
      });
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-dp-cinematic-gallery]').forEach(initializeGallery);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
